// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Rz83","selected":"Chip_selected__3FxqN"};